<template>
  <div class="laiqiu-wrapper">
    <div class="bg-glow"></div>

    <HeroSection />
    <SectionAesthetic />
    <StatsSection />
    <SectionEmpathy />
    <MissionSection />
    <TechAbility />
    <PartnersSection />
    <CommunityPreview />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import HeroSection from '@/components/New/HeroSection.vue'
import SectionAesthetic from '@/components/New/SectionAesthetic.vue'
import StatsSection from '@/components/New/StatsSection.vue'
import SectionEmpathy from '@/components/New/SectionEmpathy.vue'
import MissionSection from '@/components/New/MissionSection.vue'
import TechAbility from '@/components/New/TechAbility.vue'
import PartnersSection from '@/components/New/PartnersSection.vue'
import CommunityPreview from '@/components/New/CommunityPreview.vue'

onMounted(() => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-show')
      }
    })
  }, { threshold: 0.1 })

  document.querySelectorAll('.animate-box').forEach(el => observer.observe(el))
})
</script>

<style scoped>
:root {
  --bg: #050505;
  --text: #ffffff;
  --primary: #f3f3f3;
  --accent: #6d5dfc;
  --glass: rgba(255, 255, 255, 0.05);
  --border: rgba(255, 255, 255, 0.1);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.laiqiu-wrapper {
  background-color: #050505;
  color: #fff;
  font-family: 'Inter', 'PingFang SC', sans-serif;
  position: relative;
}

.bg-glow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 50% 50%, rgba(109, 93, 252, 0.05) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

.animate-box {
  opacity: 0;
  transform: translateY(40px);
  transition: all 1s cubic-bezier(0.16, 1, 0.3, 1);
}

.animate-box.animate-show {
  opacity: 1;
  transform: translateY(0);
}
</style>